<section class="header">
    <div class="text-right user-info-bar">
        <span style="background-color: #5d6770; color: white; padding-right: 7em;"
            >{{ userInfo?.firstName }} | <a (click)="logout()" class="logout-text">Logout</a></span
        >
    </div>
    <div class="container">
        <div class="row">
            <div class="logo-container">
                <img *ngIf="!imageHref" src="{{ imagePath }}" alt="logo" />
                <img
                    *ngIf="imageHref"
                    (click)="navigateToImageHref()"
                    class="cursor-pointer-desktop"
                    src="{{ imagePath }}"
                    alt="logo"
                />
                <div class="mobile-user-info">
                    {{ userInfo?.firstName }} | <a (click)="logout()" class="logout-text">Logout</a>
                </div>
            </div>
        </div>
    </div>
</section>
<app-loading-indicator *ngIf="isLoading"></app-loading-indicator>
